<template>
  <!-- 升降机监测 -->
  <div class="concrete-box">
    <div class="box-head">
      <p>在建项目：{{num.construction}}</p>
      <p>已安装项目数：{{num.exist}}</p>
      <p>未安装项目数：{{num.noExist}}</p>
      <p>联网设备：{{num.online}}</p>
      <p>离线设备：{{num.offline}}</p>
      <el-input  placeholder="请输入项目名称" v-model="projectName" clearable></el-input>
      <el-button type="primary" @click="doFilter">查询</el-button>
    </div>
    <div class="box-main">
      <el-table :data="tableData" style="width: 100%" height="100%" border :row-class-name="tableRowClassName" :header-row-class-name="'table-head'">
        <template slot="empty">
          <p>{{dataText}}</p>
        </template>
        <el-table-column prop="index" label="序号" width="200">
          <template slot-scope="scope">
            <span>{{scope.row.index}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="项目名称">
          <template slot-scope="scope">
            <span>{{scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="offline" label="安装数量">
          <template slot-scope="scope">
            <span>{{scope.row.all}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="online" label="联网状态">
          <template slot-scope="scope">
            <p><span style="color:#00C700;">联网 </span><span>{{scope.row.online+'/'+scope.row.all}}</span></p>
          </template>
        </el-table-column>
        <el-table-column prop="weight" label="超重">
          <template slot-scope="scope">
            <span style="color:#FF0000;">{{scope.row.weight}}次</span>
          </template>
        </el-table-column>
        <el-table-column prop="warning" label="姿态状态">
          <template >
            <span style="color:#FF0000;">0次</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="success" @click="infoFun(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--  -->
    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalItems"
    ></el-pagination>
  </div>
</template>

<script>
import myHttp from '../../untils/port';
import util from '../../untils/util';
export default {
  data(){
    return{
      groupId:'',
      tableData:[],
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      projectName:'',
      dataText: '数据加载中...',
      num:{
        construction: '0',
        exist: "0",
        noExist: '0',
        offline: "0",
        online: "0",
      },
    }
  },
  mounted(){
    this.groupId = util.session.get('groupId')
    this.getData()
    this.getNum()
  },
  methods:{
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    doFilter(){
      this.currentPage = 1
      this.getData()
    },
    //获取列表
    getData(){
      var that = this
      myHttp.elevatorListByEntId({
        entId:this.groupId,
        joniType:'3',
        projectName:this.projectName,
        pageNum:this.currentPage,
        pageSize:this.pageSize
      }).then(function(resp){
        console.log(resp)
        if(resp.data.code=='200'){
          var list = resp.data.data.pageInfo.list||[]
          for(var i=0;i<list.length;i++){
            list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
          }
          that.tableData = list
          that.totalItems = resp.data.data.pageInfo.total||0
          if (that.tableData.length == 0) {
            that.dataText = '暂无数据'
          }
        }
      })
    },
    //获取数量
    getNum(){
      var that = this
      myHttp.statisticalEquip({
        entId:this.groupId,
        joniType:'3',
        type:'3'
      }).then(function(resp){
        if(resp.data.code=='200'){
          var data = resp.data.data
          if(data){
            that.num = data
          }
        }
      })
    },

    //
    tableRowClassName({row, rowIndex}) {
      if (rowIndex%2==0) {
        return 'grey-row';
      }
      return '';
    },
    //查看
    infoFun(row){
      this.$router.push({path:'/eleEnt/'+row.id})
    },
  }
}
</script>

<style scoped>
.concrete-box{
  width: 100%;
  height: 100%;
  position: relative;
  padding: 1vh;
}
.box-head{
  width: 100%;
  height: 7vh;
  position: relative;
  display: flex;
  align-content: center;
  align-items: center;
  padding: 0 1vw;
  background: #fff;
}
.box-main{
  width: 100%;
  height: calc( 100% - 12vh );
  position: relative;
  background: #fff;
}
.grey-row{
  background: #F2F2F7;
}
.box-head p{
  width: 12vw;
  position: relative;
  text-align: left;
}
</style>

<style>
@import '../../assets/css/common.css';
/* .el-table .table-head{
    background-color: #F2F2F7;
} */
/* .concrete-box .el-table th,.concrete-box .el-table tr {
    background-color: #F2F2F7;
}
.el-table--border th, .el-table__fixed-right-patch{
    border-bottom: 1px solid #303133;
}
.el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
    border-right: 1px solid #303133;
}
.el-table td, .el-table th.is-leaf{
    border-bottom: 1px solid #303133;
}
.el-table--border, .el-table--group{
    border: 1px solid #303133;
} */
</style>